export const days = Array.from({ length: 31 }, (_, i) => `${i + 1}`);

export const monthNumbers = Array.from({ length: 12 }, (_, i) =>
	`${i + 1}`.padStart(2, "0")
);

export const months = [
	"Enero",
	"Febrero",
	"Marzo",
	"Abril",
	"Mayo",
	"Junio",
	"Julio",
	"Agosto",
	"Septiembre",
	"Octubre",
	"Noviembre",
	"Diciembre",
];

export const years = Array.from({ length: 126 }, (_, i) => `${2025 - i}`);
